module.exports = __webpack_public_path__ + "img/earth_drilling_and_digging_solutions.745bb4bb.jpg";